import React, { useRef, useState } from 'react';
import './Problem.css';
import dental1 from '../home/Images/v1.png';
import dental2 from '../home/Images/IMG20240913134831.jpg';
import dental3 from'../home/Images/IMG_20231201_174221.jpg';
import dental4 from '../home/Images/dental2.png'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {  FaCoffee, FaChild, FaClock,  FaRegCheckCircle,FaTv,FaCalendarCheck,FaTag,FaCreditCard, FaMedkit,  } from 'react-icons/fa';
import BookForm from '../book_now/BookForm';
const Problem = () => {
  const [openQuestion, setOpenQuestion] = useState(null);


  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const faqs = [
    { question: "Routine Dental Check-Ups", answer: "Regular examinations to assess the health of teeth, gums, and the overall oral cavity." },
    { question: "Professional Teeth Cleaning", answer: "Scaling and polishing to remove plaque, tartar, and stains, preventing tooth decay and gum disease." },
    { question: "Fillings and cavities", answer: "Treatment for cavities and minor tooth damage using durable materials that blend with natural teeth." },
    { question: "Tooth pain and Root Canal Treatment", answer: "Endodontic therapy by specialist to treat infected or decayed teeth, preserving them and preventing extractions." },
    { question: "Tooth Extractions", answer: "Removal of problematic teeth, including wisdom teeth or severely damaged teeth, with painless removal done by oral surgeon." },
    { question: "Missing teeth, Crowns and Bridges", answer: "Custom-fitted caps and bridges to restore and replace damaged or missing teeth, improving both function and aesthetics. Fixed replacement by best quality dental implants placed by experienced surgeons." },
    { question: "Dentures", answer: "Full or partial dentures to replace missing teeth and restore a natural-looking smile." },
    { question: "Bleeding gums and Gum Disease Treatment", answer: "Management of gingivitis and periodontitis through deep cleaning, medication, and in some cases, surgery." },
    { question: "Oral Cancer Screening", answer: "Early detection of oral cancer with routine screenings, especially important for high-risk patients." },
    { question: "Pediatric Dentistry", answer: "Specialized care for children's dental needs, including preventive treatments, fluoride treatment and education." },
    { question: "Teeth Grinding", answer: "Treatment for regular dental grinding and it's prevention by means of night guard and splint." },
    { question: "Stained teeth", answer: "Stained or yellow teeth can affect self confidence and cause embarrassment on smiling. Bombay Dental Company offers affordable teeth whitening, and Dental veneers to get the smile of your dreams." },
    { question: "Crooked teeth", answer: "Bombay dental company is a speciality Orthodontics clinic with in house full time Orthodontist to serve multiple solutions for crooked teeth, forwardly placed teeth and gaps between teeth." }
  ];
  // const featuresList = [
  //   { title: "Advanced Technology", description: "Use of state-of-the-art dental equipment and technology to provide precise and effective treatments." },
  //   { title: "Experienced Dentists", description: "A team of skilled and knowledgeable dentists dedicated to providing the highest standard of care." },
  //   { title: "Patient-Centric Approach", description: "Focus on personalized care plans and patient education to promote long-term oral health." },
  //   { title: "Comfort and Convenience", description: "Comfortable clinic environment, flexible appointment scheduling, and friendly staff to make dental visits as pleasant as possible." },
  // ];
  const apart = [
    { question: "Advanced Technology", answer: "Use of state-of-the-art dental equipment and technology to provide precise and effective treatments.    " },
    { question: "Experienced Dentists", answer: "A team of skilled and knowledgeable dentists dedicated to providing the highest standard of care." },
    { question: "Patient-Centric Approach", answer: "Focus on personalized care plans and patient education to promote long-term oral health." },
    { question: "Comfort and Convenience", answer: "Comfortable clinic environment, flexible appointment scheduling, and friendly staff to make dental visits as pleasant as possible." },
  ];
const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock  size={40} />, label: " Time Management  " },
  ];


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

   const bookFormRef = useRef(null);
  
      // Function to handle smooth scrolling
      const scrollToBookForm = (e) => {
        e.preventDefault();
        bookFormRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      };

  return (
    <div className="service">
      <section className="service-sec1">
        <div className="content">
          <div className="text-section">
            <p className="trusted-text">
              <mark className="domark">SERVICE OF BOMBAY DENTAL CLINIC</mark>
            </p>
            <h1 className="exceptional">
              <mark className="expmrk">We offer you a </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">comprehensive </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">general dental </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">care services</mark>
            </h1>
            <a onClick={scrollToBookForm}>
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">
              OR CALL <a href="tel:+918882672980">088826 72980</a>
            </p>
          </div>
        </div>
      </section>

      <section className="dental-care-container">
        <div className="image-container">
          {/* onClick={togglePlay}
          <video
            ref={videoRef}
            className="video-thumbnail"
            src={video}
            type="video/mp4"
            loop
          
          /> */}
          {/* {!isPlaying && <div className="play-button"><CgPlayButtonO /></div>} */}
        </div>
        <div className="text-container">
          <h2>Problems We Treat</h2>
          <p>
            Bombay Dental Company in Mumbai offers comprehensive general dental
            care services, ensuring optimal oral health at an affordable price
            in South Mumbai. Here are some common issues we address:
          </p>
        </div>
      </section>

      <div className="faq-section">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <button
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              aria-controls={`faq-answer-${index}`}
              aria-expanded={openQuestion === index}
            >
              {faq.question} <span>{openQuestion === index ? "-" : "+"}</span>
            </button>
            {openQuestion === index && (
              <div id={`faq-answer-${index}`} className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <section className="service-sec3">
        <div className="blueback">
          <h1 className="blueh1">Need to see a general dentist ASAP?</h1>
          <p className="bluep1">
            When problems arise, don’t wait. We offer same-day appointments to
            get you out of pain as soon as possible.{" "}
            <p className="call-text">
              OR CALL <a href="tel:+888267298"> +918882672980</a>
            </p>
            {/* <p className="call-text">9582474046</p></p> */}
          </p>
        </div>
      </section>

      <section className="checkin-container">
        <div className="whatset">
          <h1 className="problem-head">What Sets Us Apart</h1>
          <div className="faq-section">
            {apart.map((apart, index) => (
              <div className="faq-item" key={index}>
                <button
                  className="faq-question"
                  onClick={() => toggleQuestion(index)}
                  aria-controls={`faq-answer-${index}`}
                  aria-expanded={openQuestion === index}
                >
                  {apart.question}{" "}
                  <span>{openQuestion === index ? "-" : "+"}</span>
                </button>
                {openQuestion === index && (
                  <div id={`faq-answer-${index}`} className="faq-answer">
                    <p>{apart.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* <div className="image-feature-container">
          <img src={doc} alt="Patient using iPad for check-in" className="checkin-image" />
        </div> */}
      </section>
      <div
        className="dental-bar-menu"
        style={{ margin: " 0 0px", backgroundColor: "white" }}
      >
        <h2
          className="menu-title"
          style={{ textAlign: "center", color: " black" }}
        >
          Bombay Dental Company Menu
        </h2>
        <Slider {...sliderSettings}>
          {barItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div
                className="icon"
                style={{ marginBottom: "10px", color: " #0047AB" }}
              >
                {item.icon}
              </div>
              <p className="label" style={{ color: " #0047AB" }}>
                {item.label}
              </p>
            </div>
          ))}
        </Slider>
      </div>
      <div className="visit-us-container">
        <div className="images-container">
          <img src={dental1} alt="Waiting Area" className="image-item" />
          <img src={dental2} alt="Exam Room" className="image-item" />
          <img src={dental3} alt="Sign" className="image-item" />
          <img src={dental4} alt="Lounge" className="image-item" />
        </div>
        <div className="info-container">
          <h1 className="visit">Visit Us</h1>
          <p className="weare">
            We are conveniently located right on the Worli Naka, on the first
            floor of Atur House, opposite the Bharat Petroleum Pump. Our guards
            are very helpful, and free parking is provided easily upon asking.
          </p>
          <div className="lhflex">
            <div className="location">
              <h1 className="tp">
                <IoLocationOutline />
              </h1>
              <p>
                {" "}
                Bombay Dental Company
                <br />
                Atur House
                <br />
                First Floor, Flat no 2<br />
                Worli Naka, Worli
                <br />
                Mumbai 400018
              </p>
              <a
                href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                className="directions-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <div className="hours">
              <h1 className="tp">
                <IoTimeOutline />
              </h1>
              <p>
                {" "}
                Mon-Sat 9 am – 7 pm
                <br />
                Sun 10 am – 2 pm
                <br />
                Thursday off
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
            width="100%"
            height="450"
            style={{ border: "8px", borderRadius: "18px " }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location of Bombay Dental Company"
          />
        </div>
      </div>
      <div className="home-sec8">
        <div className="book-visit-container">
          <div className="online">
            <h1 className="book">Book your visit online</h1>
            <p className="view">
              Book your visit online and enjoy our unique No-wait policy, so
              that you have time for what you enjoy, and not spend your precious
              time in the doctor’s waiting area. A few lucky callers every month
              will be randomly shortlisted for a free scaling and polishing
              session.
            </p>
          </div>
        </div>
      </div>
      <div ref={bookFormRef}>
        <BookForm />
      </div>
    </div>
  );
};

export default Problem;
